import { z } from 'zod';

export const MaintenanceConfigValidator = z.object({
  enabled: z.boolean(),
  allowedIdentifiers: z.array(z.string()),
  allowedPaths: z.array(z.string()),
});

export type MaintenanceConfig = z.infer<typeof MaintenanceConfigValidator>;
